import { createColumnHelper } from '@tanstack/react-table';
import IconMap from '../../iconmap/IconMap';
import { formatIsoDate } from '@/utils/date';
import { CATEGORY_ICONS } from '../../iconmap/icons/intel_category';
import { NormalizedSignal, signalQuery } from '@/services/unifiedapi';
import DeferredDrawerLink from '@/client/features/drawerlink/DeferredDrawerLink';
import { getSignalConfig } from '@/client/features/signals/configs/signalConfigMap';

const signalsColumnHelper = createColumnHelper<NormalizedSignal>();

export const signalColumns = [
  signalsColumnHelper.accessor('published_at', {
    header: 'Source DTG',
    cell: ({ getValue }) => formatIsoDate(getValue(), true),
  }),
  signalsColumnHelper.display({
    id: 'category',
    header: 'Category',
    cell: ({ row: { original } }) => (
      <IconMap
        id={original.id}
        icons={CATEGORY_ICONS}
        map={{ [original.catalog.category?.[0]]: original.catalog.category?.[0] }}
        showTooltip
      />
    ),
    size: 120,
  }),
  signalsColumnHelper.display({
    id: 'title',
    header: 'Title',
    size: 250,
    cell: ({ row: { original } }) => {
      const value = original.title;
      const config = getSignalConfig(original.collector);

      if (!value) return null;

      return (
        <DeferredDrawerLink
          id={original.id}
          value={original.title}
          content={config.drawer(original.collector, config.title)}
          query={signalQuery(original.id)}
          link={`/signal/${original.id}`}
        />
      );
    },
  }),
  signalsColumnHelper.display({
    id: 'source',
    cell: ({
      row: {
        original: {
          catalog: { source },
        },
      },
    }) => {
      if (Array.isArray(source)) {
        return source.join(', ');
      }

      return source;
    },
    header: 'Source',
    size: 120,
  }),
];
